<template>
  <div
    v-if="visible"
    ref="report_template_wrapper"
    class="report-template-wrapper border-shadow flex-column"
    :style="{ 'z-index': zIndex }"
  >
    <div class="flex-row justify-between pd10 col-0">
      <div class="flex-row">
        <div class="mr10"><el-button size="mini" :disabled="reportLoading" @click="beforeClose">关 闭</el-button></div>
        <div class="mr10">
          <el-button size="mini" :disabled="reportLoading" @click="openRadish">查看人选</el-button>
        </div>
        <!-- <div class="mr10">
          <el-button size="mini" :disabled="reportLoading" @click="loadPrev">复制人选上一份报告</el-button>
        </div> -->

        <div v-if="fromWorkbench" class="mr10">
          <el-button size="mini" :disabled="reportLoading" type="primary" @click="saveReport({ isFinalReport: false })"
            >制作完成，发送顾问</el-button
          >
        </div>
        <div v-else class="mr10">
          <el-button size="mini" :disabled="reportLoading" type="primary" @click="saveReport({ isFinalReport: true })"
            >保存推荐报告</el-button
          >
        </div>
        <el-tooltip placement="top" style="margin-top:6px">
          <div slot="content" style="width:400px">
            推荐报告需要注意的关键点：<br /><br />
            1） 候选人动机把握：请精准体现其意图，如摩华/岗位的哪些方面打动他们，而非“更好的平台、职业发展“等套用格式<br /><br />
            2） 薪酬信息：请区分基本工资 VS 激励奖金，并注明以下 –
            税前/税后、最近一次奖金金额、奖金发放月份、是否尚未发放往年延迟支付奖金<br /><br />
            3） 其他在谈机会：如有可能，请尽早告知候选人与其他公司面试/offer的情况<br /><br />
            4） 工作时间断档：超过3个月的，请在简历中标注原因<br /><br />
            5） 除此以外，如果候选人履职现在公司不满1年的，请务必确认其看机会的原因。<br /><br />
            6） 工作职责：<br />
            i)
            渠道/机构销售类岗位：注明负责机构、省份；汇报路线，上级领导的具体职务；团队人数（汇报路线、团队人数，对于管理岗简历推荐非常重要！）
            <br />
            ii)
            基金经理：公开业绩/产品明细，包括但不限于基金产品名称、担任角色（投资经理VS助理）、产品起始时间、投资业绩、相对排名、是否静默期等
            <br />
            iii) 研究员：除消费品方向，要求候选人必须具备“复合型背景“<br />
            iv) 部门总监级别岗位：请注明其现在所属部门是一级，还是二级部门
          </div>
          <i class="el-icon-warning" style="color:#e6a23c;font-size:16px"></i>
        </el-tooltip>
      </div>
    </div>
    <div v-show="!recommendMd5" class="flex-row item-center mb10 pd-10 col-0">
      <div class="mr10">文件名：</div>
      <div class="template-input-field col-1">
        <input v-model="form.fileName" :disabled="recommendMd5" class="template-input" />
      </div>
    </div>
    <div id="reportmakerIframe" :style="`height:100% !important;width:100% !important`"></div>
    <!-- <iframe
      id="report-maker-iframe"
      width="100%"
      height="100%"
      frameborder="no"
      border="0"
      marginwidth="0"
      marginheight="0"
      scrolling="auto"
      allowtransparency="yes"
      src="/reportmarker.html"
    >
    </iframe> -->
  </div>
</template>

<script>
import { yearDiff } from '../../../../radish/src/constant/common-methods'

const dateFormat = require('dateformat')
const { download } = require('../../constant/utils')

export default {
  data() {
    return {
      form: {
        fileName: '',
        salary: '',
        不足: '',
        优势: '',
        其他: '',
        出生年月: '',
        地域: '',
        姓名: '',
        婚育: '',
        工作经历: [
          {
            下属人数: '',
            业绩: '',
            公司: '',
            汇报上级: '',
            结束时间: '',
            职位: '',
            职责: '',
            起始时间: '',
            部门: '',
            工作年月: '',
          },
        ],
        性别: '',
        总评: '',
        推荐职位: '',
        教育背景: [
          {
            起始时间: '',
            结束时间: '',
            学校: '',
            专业: '',
            学位: '',
            学校排名: '',
          },
          {
            起始时间: '',
            结束时间: '',
            学校: '',
            专业: '',
            学位: '',
            学校排名: '',
          },
        ],
        期望薪酬: '',
        爱好: '',
        特征: '',
        看法: '',
        离职动机: '',
        离职周期: '',
        籍贯: '',
        证书: '',
        谈判要点和诉求: '',
        面试时间: '',
        项目经历: [],
        英文姓名: '',
        手机: '',
        邮箱: '',
        学历: '',
        年龄: '',
        客户公司: '',
        推荐时间: '',
        应聘部门: '',
        推荐顾问: '',
        本科院校: '',
        期望地域: '',
      },

      reportLoading: false,
      recommendMd5: '',
      pipeiduText: '',
      previewUrl: '',
      token: 'Iammakingreport',
      wps: null,
      rid: '',
      pid: '',
      filemd5: '',
      radish: {},
      project: {},
      templateId: '',
      recommendReportId: '',
      onFinishReport: () => {},
      visible: false,
      zIndex: 1000,
      fromWorkbench: false,
      config: {
        document: {
          fileType: 'docx',
          key: '',
          title: '',
          url: '',
        },
        documentType: 'word',
        editorConfig: {
          actionLink: null,
          callbackUrl: `${window.host}/track`,
          coEditing: null,
          createUrl: null,
          customization: {
            about: false,
            autosave: true,
            comments: false,
            feedback: false,
            // forcesave: false,
            submitForm: false,
            compactHeader: false,
            compactToolbar: false,
            toolbarNoTabs: false,
            hideRightMenu: true,
            hideRulers: true,
            // zoom: -2,
            features: {
              spellcheck: false,
            },
            integrationMode: 'embed',
            logo: {
              image: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/assets/alpha-logo.png',
            },
            review: false,
          },
          user: {
            group: '',
            id: app.user._id,
            name: app.user.account || 'test',
          },
          region: 'zh-CN',
          lang: 'zh-CN',
          plugins: false,
        },
        mode: 'edit',
        height: '100%',
        width: '100%',
        type: 'desktop',
      },
      originalname: '',
      documentType: 'word',
      fileType: 'docx',
      md5: '',
      docEditor: null,
    }
  },
  computed: {
    download() {
      return download
    },
  },
  mounted() {
    this.config.events = {
      onError: this.destoryEditor(),
      onRequestClose: this.destoryEditor(),
    }
  },
  methods: {
    async init({ rid, pid, md5, templateId, recommendReportId, onFinishReport, loadLastWps, fromWorkbench, fileData }) {
      this.rid = rid
      this.pid = pid
      this.filemd5 = md5
      this.fromWorkbench = fromWorkbench
      this.templateId = templateId
      this.recommendReportId = recommendReportId
      if (onFinishReport) this.onFinishReport = onFinishReport
      this.zIndex = app.root.dragindex++
      this.pipeiduText = ''

      // 查找radish_project中md5和推荐概述
      const formExists = false
      const rp = await app.service('radish').getRadishProject({ rid, pid })
      if (rp.status == 'success' && rp.data) {
        if (rp.data.recommendMd5) {
          if (typeof rp.data.recommendMd5 === 'string') {
            const rmd5 = {}
            const k = `${md5}_${templateId || ''}`
            rmd5[k] = rp.data.recommendMd5
            app.service('radish').modifyRadishProject({ rid: this.rid, pid: this.pid, data: { recommendMd5: rmd5 } })
            this.recommendMd5 = rp.data.recommendMd5
          } else if (rp.data.recommendMd5[md5]) {
            // 查询第一个report
            const { data } = await window.app.service('recommendReport').find({
              query: {
                rid,
                pid,
                md5,
                $limit: 1,
                $sort: {
                  createdAt: 1,
                },
              },
            })
            if (data && data.length > 0) {
              const item = data[0]
              const spTemplateId = item.spTemplate && item.spTemplate._id ? item.spTemplate._id : ''
              this.recommendMd5 = rp.data.recommendMd5[md5] || ''
              const k = `${md5}_${spTemplateId || ''}`
              rp.data.recommendMd5[k] = rp.data.recommendMd5[md5]
              delete rp.data.recommendMd5[md5]
              app
                .service('radish')
                .modifyRadishProject({ rid: this.rid, pid: this.pid, data: { recommendMd5: rp.data.recommendMd5 } })
            } else {
              this.recommendMd5 = ''
            }
          } else {
            const k = `${md5}_${templateId || ''}`
            this.recommendMd5 = rp.data.recommendMd5[k] || ''
          }
          if (this.recommendMd5 || loadLastWps) {
            this.getLastWpsFile()
            this.$message({
              message: '数据获取中……',
              duration: 5000,
            })
            this.visible = true
            return
            // setTimeout(() => {
            //   this.getLastWpsFile()
            // }, 5000)
            // return
          }
        }
        if (rp.data.pipeiduText) {
          this.pipeiduText = rp.data.pipeiduText || ''
        } else {
          const pi = await app.service('radish').initRecommendText({ rid, pid })
          this.pipeiduText = pi.data.pipeiduText || ''
        }
      }

      const project = await app.service('project').fetch(pid)
      if (!project) return this.$message('没有项目数据')
      this.project = project
      const { data } = await app.service('radish').fetch({
        _id: rid,
        fields: { 沟通日志: 0, cvContent: 0, radishContent: 0 },
      })
      if (!data || data.length == 0) return this.$message('没有人选数据')
      // console.log('radish', data[0])
      let analyseRes = fileData || {}
      if (!fileData || !fileData.人选画像预测) {
        try {
          analyseRes = await app.service('file').analyse({ md5, force: true, category: 'xxAnalyze' })
        } catch (e) {
          this.$message('简历解析失败，请在弹出窗口中手动制作推荐报告')
        }
      }
      const radish = data[0]
      console.log('analyseRes', analyseRes)
      Object.keys(analyseRes).forEach(key => {
        const val = analyseRes[key]
        if (val && (!Array.isArray(val) || (Array.isArray(val) && val.length > 0))) {
          radish[key] = val
        }
      })
      this.radish = Object.assign({}, radish)
      this.visible = true

      await this.initForm()
      this.showWpsEditor()
    },
    async loadPrev() {
      // 查找最近的完整推荐报告md5
      const res = await app.service('radish').listAttachment({ rid: this.rid })
      isFinal
      console.log(this.rid, this.pid, res)
      if (res.status === 'success' && res.data.length > 0) {
        const attachs = res.data.filter(dt => dt.isFinal)
        if (attachs.length === 0) {
          this.$message('没有上一份报告')
          return
        }
        if (this.reportLoading) return
        this.reportLoading = true
        this.$message('推荐报告加载中……')
        attachs.sort((n, c) => (n.createdAt > c.createdAt ? -1 : 1))
        const md5 = attachs[0].md5
        try {
          // 生成编辑
          const data = await window.app.service('file').buildPreview({ md5 })
          console.log('buildPreview=====', data)
          this.previewUrl = data && data.url
          this.documentType = data && data.documentType
          this.recommendMd5 = data && data.md5
          this.originalname = data && data.originalname
          this.fileType = data && data.fileType
        } catch (error) {
          this.$message.error((error.response && error.response.message) || error.message)
        }
        this.reportLoading = false
        this.config.documentType = this.documentType
        this.config.document.fileType = this.fileType
        this.config.document.key = `${this.recommendMd5}-${Date.now()}`
        // this.config.document.key = '6f3c461968b6a727ff93320b04d58d8a'
        this.config.document.title = this.originalname
        this.config.document.url = this.previewUrl
        this.config.editorConfig.callbackUrl = `${window.host}/track?templateId=${this.templateId}&filemd5=${
          this.filemd5
        }&pid=${this.pid}&rid=${this.rid}`
        this.$nextTick(async () => {
          if (!this.docEditor) {
            this.docEditor = new window.DocsAPI.DocEditor('reportmakerIframe', this.config)
          }
        })
        if (this.recommendMd5) {
          const param = {}
          const k = `${this.filemd5}_${this.templateId || ''}`
          param[`recommendMd5.${k}`] = this.recommendMd5
          app.service('radish').modifyRadishProject({ rid: this.rid, pid: this.pid, data: param })
          if (this.recommendReportId) {
            // 保存到recommendReport
            app.service('recommendReport').patch(this.recommendReportId, { recommendMd5: this.recommendMd5 })
          }
        }
      } else {
        this.$message('没有上一份报告')
      }
    },
    async getLastWpsFile() {
      // 加载最新版本文件
      if (this.reportLoading) return
      this.reportLoading = true
      this.$message('推荐报告加载中……')

      try {
        const { status, data, message } = await app
          .service('file')
          .getOnlyOfficeFileHistoryVersion({ md5: this.recommendMd5 })
        console.log('getSharedWpsFile=====', status, data, message)
        if (status === 'success') {
          this.previewUrl = data && data.url
          this.documentType = data && data.documentType
          this.recommendMd5 = data && data.md5
          this.originalname = data && data.originalname
          this.fileType = data && data.fileType
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        this.$message.error((error.response && error.response.message) || error.message)
      }
      this.reportLoading = false
      this.config.documentType = this.documentType
      this.config.document.fileType = this.fileType
      this.config.document.key = `${this.recommendMd5}-${Date.now()}`
      // this.config.document.key = '6f3c461968b6a727ff93320b04d58d8a'
      this.config.document.title = this.originalname
      this.config.document.url = this.previewUrl
      this.config.editorConfig.callbackUrl = `${window.host}/track?templateId=${this.templateId}&filemd5=${
        this.filemd5
      }&pid=${this.pid}&rid=${this.rid}`
      this.$nextTick(async () => {
        if (!this.docEditor) {
          this.docEditor = new window.DocsAPI.DocEditor('reportmakerIframe', this.config)
        }
      })
    },
    async initForm() {
      const today = dateFormat(new Date(), 'yyyy-mm-dd')
      const form = {
        姓名: this.radish['姓名'] || '',
        性别: this.radish['性别'] || '',
        婚育: this.radish['婚育'] || '',
        出生年月: this.radish['出生年月'] || '',
        地域: (this.radish['地域'] && Array.isArray(this.radish['地域']) && this.radish['地域'].join('、')) || '',
        fileName: `${this.radish['姓名']}${
          this.radish['公司'] && this.radish['公司'].length <= 12 ? `-${this.radish['公司']}` : ''
        }${this.project.项目名称 ? `-${this.project.项目名称}` : ''}${
          this['地域'] ? `-${this['地域']}` : ''
        }-阿尔法咨询-${today}.docx`,
        教育背景: await this.formatAnalyseExp(this.radish['教育经历'], '教育'),
        工作经历: await this.formatAnalyseExp(this.radish['工作经历'], '工作'),
        项目经历: await this.formatAnalyseExp(this.radish['项目经历'], '项目'),
        籍贯: this.radish['籍贯'] || '',
        离职动机: this.radish['离职动机'] || '',
        谈判要点和诉求: this.radish['谈判要点和诉求'] || '',
        离职周期: this.radish['离职周期'] || '',
        证书:
          this.radish['证书'] ||
          (this.radish.职业资格 && Array.isArray(this.radish.职业资格) ? this.radish.职业资格.join('、') : ''),
        英文姓名: this.radish.英文名 || '',
        手机: this.radish.手机 || '',
        邮箱: this.radish.邮箱 || '',
        学历: this.radish.学历 || '',
        客户公司: this.project.客户公司 || '',
        推荐时间: today,
        推荐职位: this.project.项目名称 || '',
        应聘部门: this.project.部门 || '',
        特征:
          (this.radish['个人风格'] && Array.isArray(this.radish['个人风格']) && this.radish['个人风格'].join('、')) ||
          '',
        推荐顾问: app.user.account,
        本科院校: this.radish.本科院校 || '',
        期望地域:
          (this.radish['期望地域'] && Array.isArray(this.radish['期望地域']) && this.radish['期望地域'].join('、')) ||
          '',
      }
      const year = new Date().getFullYear()
      const birth = this.radish.出生年月
      if (birth) {
        const birthInt = parseInt(birth)
        if (!isNaN(birthInt) && birthInt > 999) {
          form.年龄 = `${year - birthInt}岁`
        }
      }
      const wholeYearSalary =
        this.radish.money && this.radish.money[year] && this.radish.money[year]['全薪']
          ? this.radish.money[year]['全薪']
          : ' '
      const wholeFixSalary =
        this.radish.money && this.radish.money[year] && this.radish.money[year]['固薪']
          ? this.radish.money[year]['固薪']
          : ' '
      const wholeBonusSalary =
        this.radish.money && this.radish.money[year] && this.radish.money[year]['奖金']
          ? this.radish.money[year]['奖金']
          : ' '
      form.salary = `年薪税前 ${wholeYearSalary} 万，其中，固薪税前 ${wholeFixSalary} 万，奖金税前 ${wholeBonusSalary} 万`

      const expectFixSalary = this.radish['期望固薪'] || ' '
      const expectBonusSalary = this.radish['期望奖金'] || ' '
      form.期望薪酬 = `期望固薪税前 ${expectFixSalary} 万，奖金税前 ${expectBonusSalary} 万`

      if (this.recommendReportId) {
        const rp = await app.service('recommendReport').get(this.recommendReportId)
        form.推荐顾问 = rp.sender
      }

      if (this.radish.人选画像预测) {
        const you = this.radish.人选画像预测.highlights
        const lie = this.radish.人选画像预测.risks
        console.log('youlie', you, lie)
        let youText = ''
        let lieText = ''
        if (you) {
          if (you.project && you.project.length > 0) youText += `${you.project.join('，')}\n`
          if (you.occupation && you.occupation.length > 0) youText += `${you.occupation.join('，')}\n`
          if (you.education && you.education.length > 0) youText += `${you.education.join('，')}\n`
          if (you.others && you.others.length > 0) youText += `${you.others.join('，')}\n`
          if (you.tags && you.tags.length > 0) youText += `${you.tags.join('，')}\n`
        }
        if (lie) {
          if (lie.occupation && lie.occupation.length > 0) lieText += `${lie.occupation.join('，')}\n`
          if (lie.education && lie.education.length > 0) lieText += `${lie.education.join('，')}\n`
          if (lie.tags && lie.tags.length > 0) lieText += `${lie.tags.join('，')}\n`
        }
        form.优势 = youText
        form.不足 = lieText
        console.log('youlietext', form.优势, form.不足)
      }

      let keyTags = []
      if (this.radish['业绩']) {
        keyTags =
          this.radish['业绩'] === 'aaa'
            ? ['AAA卓越人选']
            : this.radish['业绩'] === 'aa'
            ? ['AA卓越人选']
            : this.radish['业绩'] === 'a'
            ? ['A优秀人选']
            : ['一般人选']
      }
      if (this.radish['职能模块'] && this.radish['职能模块'].length && this.radish['职能模块'].length > 0) {
        keyTags = keyTags.concat(this.radish['职能模块'])
      }
      if (this.radish['擅长方向'] && this.radish['擅长方向'].length && this.radish['擅长方向'].length > 0) {
        keyTags = keyTags.concat(this.radish['擅长方向'])
      }
      if (this.radish['平台'] && (this.radish['平台'] === 'A' || this.radish['平台'] === 'B')) {
        keyTags = keyTags.concat(this.radish['平台'] === 'A' ? '大平台' : '中型平台')
      }
      if (this.radish['学历标签'] && this.radish['学历标签'].length && this.radish['学历标签'].length > 0) {
        keyTags = keyTags.concat(this.radish['学历标签'])
      }
      form.总评 = keyTags.join(', ') + this.pipeiduText ? `\n${this.pipeiduText}` : ''
      this.form = Object.assign({}, this.form, form)
      await this.fetchRadishCommunication(this.rid)
    },
    async showWpsEditor() {
      await this.generateDocx()
      this.config.documentType = this.documentType
      this.config.document.fileType = this.fileType
      this.config.document.key = `${this.recommendMd5}-${Date.now()}`
      // this.config.document.key = '6f3c461968b6a727ff93320b04d58d8a'
      this.config.document.title = this.originalname
      this.config.document.url = this.previewUrl
      this.config.editorConfig.callbackUrl = `${window.host}/track?templateId=${this.templateId}&filemd5=${
        this.filemd5
      }&pid=${this.pid}&rid=${this.rid}`

      this.$nextTick(async () => {
        if (!this.docEditor) {
          this.docEditor = new window.DocsAPI.DocEditor('reportmakerIframe', this.config)
        }
      })
    },
    async fetchRadishCommunication(rid) {
      try {
        const communication = await window.app.service('communication').testPaper({ radishId: rid })
        if (communication['11'] && communication['11'].answer && !this['离职动机']) {
          this.form.离职动机 = communication['11'].answer.join('\n')
        }
        if (communication['7'] && communication['7'].answer && !this['谈判要点和诉求']) {
          this.form.谈判要点和诉求 = communication['7'].answer.join('\n')
        }
        if (communication['12'] && communication['12'].text && !this['离职周期']) {
          this.form.离职周期 = communication['12'].text
        }
        // 软性标签
        if (communication && communication.tags && communication.tags.length > 0 && this['软性标签']) {
          let ruan = []
          communication.tags.forEach(c => {
            if (c.checkList) ruan = ruan.concat(c.checkList)
          })
          this.form.总评 = this.form.总评 + ruan.join(', ')
        }
      } catch (e) {
        console.error(e)
      }
    },
    async formatAnalyseExp(exps, type) {
      if (!exps) return []
      const fexps = exps.map(val => {
        let result = {}
        if (type == '工作') {
          result = {
            下属人数: '',
            业绩: '',
            公司: '',
            汇报上级: '',
            结束时间: '',
            职位: '',
            职责: '',
            起始时间: '',
            部门: '',
            工作年月: yearDiff(val.起始时间, val.结束时间),
          }
        } else if (type == '教育') {
          result = {
            起始时间: '',
            结束时间: '',
            学校: '',
            专业: '',
            学位: '',
            学校排名: '',
            学历标签: '',
          }
        }
        for (const key in val) {
          const fieldMap = {
            目前职位: '职位',
            工作职责: '职责',
            工作业绩: '业绩',
            项目职责: '职责',
            项目业绩: '业绩',
            项目描述: '描述',
            项目名称: '名称',
            项目职务: '职位',
            学历: '学位',
          }
          if (['工作职责', '项目职责'].includes(key)) {
            result['职责'] = val[key].replace(/<\/?.+?>/g, '').replace(/[\r\n]/g, '')
          } else if (fieldMap[key]) {
            result[fieldMap[key]] = val[key]
          } else {
            result[key] = val[key]
          }
        }
        return result
      })
      // 教育经历学历标签
      if (exps.length > 0 && type == '教育') {
        const schools = fexps.map(edu => edu.学校)
        if (schools.length > 0) {
          const res = await app.service('misc').getScoolInfoByNames({ name: schools })
          if (res.status == 'success') {
            fexps.forEach(edu => {
              const school = edu.学校
              if (school) {
                if (res.data[school].学历标签) {
                  res.data[school].学历标签.sort((a, b) => {
                    const order = ['985', '211', 'QS100', 'TIMES100']
                    return order.indexOf(a) - order.indexOf(b)
                  })

                  edu.学历标签 = res.data[school].学历标签[0] || ''
                }
              }
            })
          }
        }
      }
      return fexps
    },
    beforeClose() {
      this.$alert('您将关闭推荐报告制作页面，已填写信息已自动保存', '提示', {
        confirmButtonText: '确定',
        showClose: false,
        callback: action => {
          this.destoryEditor()
          this.close()
        },
      })
    },
    close() {
      this.visible = false
      console.info(app.name)
      window.app.root.$refs.cvPreview.close()
    },
    async generateDocx() {
      if (this.reportLoading) return
      this.reportLoading = true
      this.$message('推荐报告生成中……')
      const form = this.form
      console.log('form', form)
      try {
        const { status, data, message } = await window.app.service('file').generateCv({
          form,
          templateId: this.templateId,
        })
        console.log('generateCv=====', status, data, message)
        if (status === 'success') {
          this.previewUrl = data && data.url
          this.documentType = data && data.documentType
          this.originalname = data && data.originalname
          this.fileType = data && data.fileType
          // this.token = data && data.token
          // 设定一个只用于编辑的token
          // this.token = 'Iammakingreport'
          this.recommendMd5 = (data && data.md5) || ''
          // 保存md5到radish_project
          if (this.recommendMd5) {
            const param = {}
            const k = `${this.filemd5}_${this.templateId || ''}`
            param[`recommendMd5.${k}`] = this.recommendMd5
            app.service('radish').modifyRadishProject({ rid: this.rid, pid: this.pid, data: param })
            if (this.recommendReportId) {
              // 保存到recommendReport
              app.service('recommendReport').patch(this.recommendReportId, { recommendMd5: this.recommendMd5 })
            }
          }
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        this.$message.error((error.response && error.response.message) || error.message)
      }
      this.reportLoading = false
      // this.previewUrl = `https://wwo.wps.cn/office/w/c879c403d72173212f8b8b97e7a53e71?_w_appid=153fddf3d32e492396d585190eba1403&_w_tokentype=1&_w_signature=JLEWrYWeBD2MoBnIak0McU%2FL0Zw%3D&_account=LanBin`
    },

    async saveReport({ isFinalReport }) {
      this.reportLoading = true
      this.destoryEditor()
      const param = { rid: this.rid, pid: this.pid, md5: this.recommendMd5 }
      param.isFinalReport = isFinalReport
      this.$message({
        message: '推荐报告保存中……',
        duration: 20000,
      })
      setTimeout(async () => {
        try {
          const res = await app.service('file').downloadOnlyOfficeFile(param)
          if (res && res.data) {
            console.log('downloadFile=====', res)
            if (isFinalReport) {
              if (this.recommendReportId) {
                // 行政工作台completed
                app.service('recommendReport').patch(this.recommendReportId, { completed: true })
                // 修改notify
                app.service('notify').modifyNotify({
                  query: { rid: this.rid, pid: this.pid, type: '推荐报告', recommendReportId: this.recommendReportId },
                  data: { completed: true },
                })
              }
              // 顾问保存
              download({ md5: res.data.md5 })
            } else {
              // 数据
              this.onFinishReport({ _id: this.recommendReportId })
            }
          } else {
            console.error('saveReport res', res)
          }
        } catch (error2) {
          console.error('saveReport2', error2)
        }
        this.reportLoading = false
        this.close()
      }, 20000)
    },
    openRadish() {
      window.open(`${window.frontend}/#/radish-detail-blank/${this.rid}`, '_blank')
    },
    destoryEditor() {
      this.docEditor && this.docEditor.destroyEditor()
      this.docEditor = null
    },
  },
}
</script>

<style scoped>
.report-template-wrapper {
  position: fixed;
  top: 60px;
  right: 0;
  bottom: 0;
  left: 43%;
  padding: 0;
  border-radius: 0 !important;
  max-height: 100vh;
  background-color: #fff;
  /* overflow: auto; */
  overflow-y: hidden;
  width: 57vw;
}
.report-template {
  position: relative;
  padding: 100px 10px 30px 10px;
  font-size: 1rem;
  line-height: 20px;
  overflow-y: scroll;
}

.report-logo {
  position: absolute;
  left: 0;
  top: 0;
}
.template-input-field {
  position: relative;
  padding-top: 5px;
  padding-bottom: 5px;
  outline: 0;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 1rem;
  background: #fff;
}
.template-input-field:before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  border: 1px hidden;
  border-bottom: 1px solid;
  background: transparent;
  pointer-events: none;
  content: '';
  color: #bdbdbd;
}
.template-input {
  height: 20px;
  display: block;
  -webkit-appearance: none;
  width: 100%;
  border: 0;
  outline: 0;
  padding: 0;
  background: transparent;
  line-height: 20px;
  font-size: inherit;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #000;
  text-overflow: ellipsis;
  overflow: hidden;
}
.name-input {
  height: 28px;
  -webkit-appearance: none;
  border: 0;
  border-bottom: 1px solid #bdbdbd;
  outline: 0;
  padding: 0;
  background: transparent;
  line-height: 28px;
  font-size: inherit;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #000;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
}
.name {
  font-size: 24px;
  text-align: center;
}

.handler {
  display: inline-block;
  padding: 4px 6px;
  font-size: 16px;
  border-radius: 6px;
}
.handler-close {
  color: #f44336;
}
.handler-close:hover {
  background: #f44336;
  border-color: #f44336;
  color: #fff;
}
.time-input {
  width: 100px;
}
.flex-start {
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}
.handler-confirm {
  color: #409eff;
  background: #ecf5ff;
  border: 1px solid #b3d8ff;
}
.handler-confirm:hover {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}
.el-icon-remove {
  color: #f44336;
  font-size: 20px;
  cursor: pointer;
}
.exp-handlers {
  position: absolute;
  left: 0;
  top: 60px;
}
.question-body {
  font-size: 16px;
  font-weight: 800;
}
.answer-head {
  font-size: 14px;
  font-weight: 800;
}
</style>
